import { genericMemo } from "@redotech/react-util/component";
import { DropTargetMonitor, useDragLayer, useDrop } from "react-dnd";
import { Flex } from "../flex";
import { FormElementDrag } from "./form-element-drag";

export const FormElementDrop = genericMemo(function FormElementDrop<
  T extends string,
>({
  hideUntilDragging,
  elementDropped,
  possibleValues,
  children,
}: {
  hideUntilDragging?: boolean;
  elementDropped(elementType: T): void;
  possibleValues: readonly T[];
  children?: React.ReactNode;
}) {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: [...possibleValues],
      drop(_item: typeof FormElementDrag, monitor) {
        elementDropped(monitor.getItemType() as any);
        return undefined;
      },
      collect: (monitor: DropTargetMonitor) => ({ isOver: monitor.isOver() }),
    }),
    [elementDropped],
  );

  const isDragging = useDragLayer((monitor) => monitor.isDragging());
  const hasHeight = !hideUntilDragging || isDragging;

  return children ? (
    <Flex
      ref={drop}
      style={{ opacity: isOver ? 0.7 : 1, transition: "opacity 0.2s ease" }}
      w="full"
    >
      {children}
    </Flex>
  ) : (
    <div
      ref={drop}
      style={{ height: hasHeight ? "16px" : 0, padding: hasHeight ? "6px" : 0 }}
      width="100%"
    >
      {isOver && <div style={{ height: "4px", background: "#4D35C6" }} />}
    </div>
  );
});
